import { getRoute } from "@/functions/getRoute";
import { getGlobal } from "@/functions/getGlobal";
import { consultant_helper } from "@/helpers/consultant_helper";
import { jobs_helper } from "@/helpers/jobs_helper";
import { blog_helper } from "@/helpers/blog_helper";
import ConsultantProfile from "@/components/ConsultantProfile"; 
import LatestJobs from "@/components/LatestJobs";
import LatestBlogs from "@/components/LatestBlogs";
import BackButton from "@/components/BackButton";
import SeoHead from "@/components/SeoHead";

export default function ConsultantPage({ consultant, all_jobs }) {
  const global = getGlobal();

  return (
    <>
      <main>
        <SeoHead
            page_name={`${consultant?.name} | EarthStream`}
            description={`Get in touch with ${consultant?.name} today via email, phone or on Linkedin.`}
            canonical_link={`https://www.earthstreamglobal.com/consultants/${consultant?.url_slug}`}
          />
        <div style={{padding: '100px 60px 0'}}>
          <BackButton/>
        </div>
        <ConsultantProfile consultant={consultant}/>
        <LatestJobs jobs={all_jobs} title={""} internal={false}></LatestJobs>
        <LatestBlogs
          title={{path: "page.home.latest-blogs.Header.title", placeholder: "LATEST NEWS & INSIGHTS"}}
          items={blog_helper.fetch({limit: 3})}
          backgroundColor='white'
          author={consultant}
        >
        </LatestBlogs>
        
      </main>
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const consultant = consultant_helper.find(url_slug);
  // const all_jobs = jobs_helper.fetch().filter((job) => job.consultant_name?.toLowerCase() === consultant.name?.toLowerCase());
  
  const all_jobs = jobs_helper.fetch().filter((job) =>
    job.categories?.some((category) =>
      category.name === 'Consultants' &&
      category.values.some((consultantValue) =>
        consultantValue.name.toLowerCase() === consultant.name?.toLowerCase()
      )
    )
  );  

  return {
    props: {
      consultant,
      all_jobs
    },
  };
}

export async function getStaticPaths() {
  return { paths: consultant_helper.toPaths(), fallback: false };
}
